module.exports = __webpack_public_path__ + "static/img/muhammadiyah.ec4ea21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/muhammadiyah.jpg
// module id = GeLc
// module chunks = 15